<template>
    <div>
        <Scene17/>
        <Scene18/>
    </div>
</template>

<script>
import { Sprite, Container } from 'pixi.js'
import ChapterMixin from '@/mixins/Chapter'
import Scene17 from './scenes/Scene17'
import Scene18 from './scenes/Scene18'

export default {
    name: 'PeaceTower',
    mixins: [ ChapterMixin ],
    components: { Scene17, Scene18 },
}
</script>
